'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var navigateTo = exports.navigateTo = function navigateTo(url) {
  window.location.href = url;
};

var openNewTab = exports.openNewTab = function openNewTab(url) {
  window.open(url, '_blank');
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/navigation/url.js
// module id = 301
// module chunks = 3 4 5